import {Component, Input} from '@angular/core';

@Component({
  selector: 'liberro-data-load-error',
  standalone: false,
  templateUrl: './liberro-data-load-error.component.html',
  styleUrl: './liberro-data-load-error.component.less'
})
export class LiberroDataLoadErrorComponent {
  @Input() public type: 'overlay' | 'attach' | 'inline' = 'inline';
  @Input() public translationKey = 'global.dataLoadErrorReload';
}
